/**
 * Profile tabs resource (CT-5286).
 *
 * The tabs a Unified Profile opens with, per entity type. Overview is NOT one
 * of them: it is the screen's single invariant and the frontend guarantees it,
 * so an outage here costs the user the extras, never the profile.
 *
 * Real signatures and snake_case bodies; only the transport is stubbed.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

export { __resetMockProfileTabsForTests } from './__mocks__/profileTabs.mock.js';

/**
 * Map a raw API tab onto what the shell renders.
 *
 * `label` comes from the payload, not from an i18n key: the tab set is
 * tenant-shaped, so there is no fixed key list to translate against. `kind` is
 * what the renderer registry dispatches on, and an unrecognised one is passed
 * through untouched — the screen degrades on it rather than the mapper
 * pretending it is something else.
 */
export const mapApiProfileTabToUi = (raw = {}) => ({
  id: raw.tab_id ?? raw.tabId ?? raw.id ?? '',
  label: raw.label ?? raw.name ?? '',
  kind: raw.kind ?? raw.type ?? '',
  module: raw.module ?? null,
});

/**
 * TODO(CT-5286 / backend): `POST /v1/workspace/profiles/tabs/list` with
 * `{ entity_type }`.
 */
export const listProfileTabs = async ({ entityType } = {}) => {
  const response = await request('/v0/profile/tabs/list', { entity_type: entityType });
  return validateApiResponse(response, 'Failed to load profile tabs');
};
